import React, { createContext, useContext } from "react";

export const ROLES = {
  STATUTORY_ADMIN: {
    id: "STATUTORY_ADMIN",
    label: "Statutory Admin",
    description: "Full configuration access — create, edit, advance status",
    canWrite: true,
    canApprove: true,
    canCreateRuleVersions: true,
  },
  STATUTORY_ANALYST: {
    id: "STATUTORY_ANALYST",
    label: "Statutory Analyst",
    description: "Evidence management, interpretation, eligibility review",
    canWrite: true,
    canApprove: true,
    canCreateRuleVersions: false,
  },
  AUDITOR: {
    id: "AUDITOR",
    label: "Auditor",
    description: "Read-only access — audit history, evidence, rule versions",
    canWrite: false,
    canApprove: false,
    canCreateRuleVersions: false,
  },
};

const StatutoryContext = createContext(null);

export function StatutoryProvider({ children }) {
  const [role, setRole] = React.useState(() => {
    try { return localStorage.getItem("statutory_mock_role") || "STATUTORY_ADMIN"; } catch { return "STATUTORY_ADMIN"; }
  });

  const handleSetRole = (r) => {
    setRole(r);
    try { localStorage.setItem("statutory_mock_role", r); } catch {}
  };

  const currentRole = ROLES[role] || ROLES.STATUTORY_ADMIN;

  return (
    <StatutoryContext.Provider value={{ role, setRole: handleSetRole, currentRole }}>
      {children}
    </StatutoryContext.Provider>
  );
}

export function useStatutory() {
  const ctx = useContext(StatutoryContext);
  if (!ctx) throw new Error("useStatutory must be used within StatutoryProvider");
  return ctx;
}
